export default function getStringFromObject(obj: Record<string, string>): string {

    const objtoArr = Object.keys(obj).map((key) => {
        return `${key}:${obj[key]}`;
    });
    return objtoArr.join(';');

}
